<template>
  <div id="app">
    <Header></Header>
    <div class="contain">
      <!-- <keep-alive> -->
      <router-view :key="$route.fullPath" />
      <!-- </keep-alive> -->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
export default {
  name: "App",
  components: { Header, Footer },
  created () {
    let id = sessionStorage.getItem("id");
    if (id != undefined) { //登录了
      this.$store.dispatch('changCertific', id)
    }
  },
  mounted () {

  },
  methods: {

  },
};
</script>

<style lang="scss">
* {
  margin: 0px;
  padding: 0px;
}
html {
  width: 100%;
}
body {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1505px;
}
#app {
  width: 100%;
  min-height: 100vh;
  min-width: 1405px;
  height: auto;
  padding-bottom: 334px;
}
.contain {
  width: 100%;
  height: auto;
}
.my_popover {
  background: #f5f9ff;
}
.my_popover img {
  max-width: 480px;
  max-height: 480px;
}
.el-cascader-menu {
  height: 300px;
  max-width: 100px;
}
.my_cascader {
  border-radius: 0;
  margin-top: 5px !important;
  // .el-cascader-menu:nth-child(1) {
  //   .el-cascader-node:nth-child(1) {
  //     // display: none;
  //   }
  // }

  // 清除级联选择器小圆角
  .el-cascader-node > .el-radio,
  .el-radio:last-child {
    margin-right: 0;
    display: none;
  }
  // 级联选择--鼠标悬浮或聚焦时选择项背景色和字体颜色
  .el-cascader-node:not(.is-disabled):focus,
  .el-cascader-node:not(.is-disabled):hover {
    background: #1395ee;
    color: #fff;
  }
  .el-cascader-node.is-selectable.in-active-path {
    background: #1395ee;
    color: #fff;
  }
  // .el-cascader-node .is-selectable .in-checked-path .is-active {
  //   background: #1395ee !important;
  //   color: #fff;
  // }
  .popper__arrow {
    display: none;
  }
  // 解决ie浏览器级联选择器选项右边箭头不居中对齐
  [class*=" el-icon-"],
  [class^="el-icon-"] {
    line-height: 2;
  }
  .el-cascader-node__postfix {
    display: none;
  }
  .el-cascader-menu {
    float: left;
  }
}
// 解决ie9不支持transform属性，下拉框三角图标初始方向错误
.el-select .el-input .el-select__caret {
  -ms-transform: rotate(180deg);
  -sand-transform: rotate(180deg);
}
// 解决ie9不支持transform属性，下拉框三角图标不能反转
.el-select .el-input .el-select__caret.is-reverse {
  -ms-transform: rotate(0deg);
  -sand-transform: rotate(0deg);
}
// 解决ie9不支持transform属性，级联选择器三角图标不能反转
.el-cascader .el-input .is-reverse.el-icon-arrow-down {
  -ms-transform: rotate(180deg);
  -sand-transform: rotate(180deg);
}

// .el-cascader-node.in-active-path,
// .el-cascader-node.is-active,
// .el-cascader-node.is-selectable.in-checked-path {
//   background: #1395ee !important;
//   color: #fff;
// }
/* 移除下拉框小三角 */
.my_select {
  border-radius: 0;
  margin-top: 5px !important;
  .popper__arrow {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue